<template>
    <div>
        <div class="row mb-2">
            <div class="col-4 p-2">
                <div class="box-titel color-back1">
                    <div class="row">
                        <div class="col-9 text-center text-primary h7 py-2">
                            تعداد اسناد
                        </div>
                        <div class="col-3"></div>
                    </div>
                    <div class="row">
                        <div class="col-9 text-center h3 text-info">1024</div>
                        <div class="col-3 text-right">
                            <i class="fab fa-buffer fa-3x text-info"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4 p-2">
                <div class="box-titel color-back2">
                    <div class="row">
                        <div class="col-9 text-center text-primary h7 py-2">
                            مانده بدهکاران
                        </div>
                        <div class="col-3"></div>
                    </div>
                    <div class="row">
                        <div class="col-9 text-center h3 text-info">10,570,000</div>
                        <div class="col-3 text-right">
                            <i class="far fa-arrow-alt-circle-right fa-3x text-info"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4 p-2">
                <div class="box-titel color-back3">
                    <div class="row">
                        <div class="col-9 text-center text-primary h7 py-2">
                            مانده بستانکاران
                        </div>
                        <div class="col-3"></div>
                    </div>
                    <div class="row">
                        <div class="col-9 text-center h3 text-info">25,430,000</div>
                        <div class="col-3 text-right">
                            <i class="far fa-arrow-alt-circle-left fa-3x text-info"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-4 p-2">
                <div class="box-titel chart-size">
                    <PlanetChart v-bind:ChartData="planetRightChartData" v-bind:ChartID="1"/>
                </div>
            </div>
            <div class="col-8 p-2">
                <div class="box-titel chart-size">
                    <PlanetChart v-bind:ChartData="planetLeftChartData" v-bind:ChartID="2"/>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-4 p-2">
                <div class="box-titel box-table">
                    <table
                        class="
                        table table-bordered table-sm
                        text-center
                        table-font-size
                        m-0
                        "
                    >
                        <thead class="text-info color-back1">
                            <td colspan = "5">آخرین اسناد</td>
                        </thead>
                        <thead class="text-info color-back1">
                            <td>ردیف</td>
                            <td>کد حساب</td>
                            <td>تاریخ</td>
                            <td>نوع</td>
                            <td>مبلغ</td>
                        </thead>

                        <tbody>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-4 p-2">
                <div class="box-titel box-table">
                    <table
                        class="
                        table table-bordered table-sm
                        text-center
                        table-font-size
                        m-0
                        "
                    >
                        <thead class="text-info color-back2">
                            <td colspan = "5">ترازنامه حساب های کل</td>
                        </thead>
                        <thead class="text-info color-back2">
                            <td>ردیف</td>
                            <td>کد حساب</td>
                            <td>تاریخ</td>
                            <td>نوع</td>
                            <td>مبلغ</td>
                        </thead>
                        <tbody>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-4 p-2">
                <div class="box-titel box-table">
                    <table
                        class="
                        table table-bordered table-sm
                        text-center
                        table-font-size
                        m-0
                        "
                    >
                        <thead class="text-info color-back3">
                            <td colspan = "5">گردش بانک ها</td>
                        </thead>
                        <thead class="text-info color-back3">
                            <td>ردیف</td>
                            <td>کد حساب</td>
                            <td>تاریخ</td>
                            <td>نوع</td>
                            <td>مبلغ</td>
                        </thead>
                        <tbody>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PlanetChart from './ChartComponents/PlanetChart.vue'
import LeftChartData from './ChartComponents/left-chart-data.js'
import RightChartData from './ChartComponents/right-chart-data.js'

export default {
    components: {
        PlanetChart
    },
    data() {
        return {
            planetLeftChartData: LeftChartData,
            planetRightChartData: RightChartData,
        }
    },
    methods: {

    }
}
</script>

<style scoped>
    .box-titel {
        /* border: 1px solid #dee2e6; */
        box-shadow: rgb(0 0 0 / 10%) 0px 1px 5px;
        border-radius: 5px;
        /* min-height: 100px; */
    }

    .box-table {
        padding: 5px;
    }

    .thead-color1 {
        background-color: rgba(255, 205, 86, 0.3);
    }

    .thead-color2 {
        background-color: rgba(75, 192, 192, 0.3);
    }

    .thead-color3 {
        background-color: rgba(153, 102, 255, 0.3);
    }

    .box-table table tbody tr td{
        height: 22px;
    }

    .chart-size {
        height: 268px;
    }

    .color-back1 {
        background-color: #f7f7f7;
    }

    .color-back2 {
        background-color: #ffecf0;
    }

    .color-back3 {
        background-color: #f5fdff;
    }
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/Dashboard/Dashboard.vue